import { styled } from "linaria/react";

export const Section = styled.div`
    margin: 0 30px;
`;
